
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone-verification",
      function () {
        return require("private-next-pages/phone-verification/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone-verification"])
      });
    }
  